export default __webpack_public_path__ + "static/media/pic6.6664cd82.jpg";